import React, { PureComponent } from 'react';
import axios from 'axios';
import { Form, Input, Button, Row, Col, Select, notification } from 'antd';
import { FormattedMessage } from "react-intl";
import countryList from 'react-select-country-list'
import { cw, hp } from "../../utils";

import AuthHeader from './Header';

class SignUp extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            country: {
                location: {},
                country_name: 'Ghana',
                country_code: ''
            },
            countries: countryList().getData(),
            recaptcha: null, screen: 0, submitting: false
        };
    }

    componentDidMount() {
        this.ipinfo();
    }

    ipinfo = () => {
        axios({
            method: 'POST',
            url: `${hp.getApiBaseUrl()}/ipinfo`,
            json: true
        }).then((res) => {
            if (res.data.country_name) {
                this.setState({ country: res.data, fetching: false });
            }
        }).catch((err) => {
            this.setState({ fetching: false });
        });
    }

    _signup = e => {
        e.preventDefault();
        const { form: { validateFields }, } = this.props;
        validateFields((err, v) => {
            if (!err) {
                this.setState({ submitting: true });
                axios({
                    method: 'POST',
                    url: `${hp.getApiBaseUrl()}/users/${hp.getCookie('user_id')}/accounts`,
                    json: true,
                    data: {
                        name: v.organizationName,
                        industry: v.industry,
                        country: v.organizationCountry,
                    },
                    headers: {
                        'x-access-token': hp.getCookie('user_token')
                    }
                }).then((res) => {
                    if (res.data.statusCode === 200) {
                        hp.setCookie('project_id', res.data.data.id);
                        hp.setCookie('active_account', JSON.stringify(res.data.data));
                        axios({
                            method: 'POST',
                            url: `${hp.getApiBaseUrl()}/auth/account-logins`,
                            headers: { 'x-access-token': hp.getCookie('user_token') },
                            data: {
                                accountId: res.data.data.id,
                                userId: hp.getCookie('user_id'),
                            }
                        }).then((response) => {
                            const res = response.data;
                            if (res.statusCode === 200) {
                                hp.setCookie('user_token', res.token);
                                window.location.assign(process.env.REACT_APP_SUCCESS_REDIRECT);
                            } else {
                                notification.error({ message: this.props.intl.formatMessage(cw['SwitchAccount.Failed']) });
                            }
                        }).catch(() => {
                            notification.error({ message: this.props.intl.formatMessage(cw['SwitchAccount.Failed']) });
                        });
                    } else {
                        this.setState({ submitting: false });
                        notification.error({
                            message: this.props.intl.formatMessage(cw['Failed']),
                            description: this.props.intl.formatMessage(cw['Signup.Failed'])
                        });
                    }
                }).catch((err) => {
                    this.setState({ submitting: false });
                    notification.error({
                        message: this.props.intl.formatMessage(cw['Failed']),
                        description: this.props.intl.formatMessage(cw['Signup.Failed'])
                    });
                });
            }
        });
    };

    render() {
        const { form: { getFieldDecorator, getFieldsValue }, _utils, } = this.props;

        return (
            <React.Fragment>
                <Form id="esoko__signin" hideRequiredMark={true} onSubmit={this._signup}>
                    <AuthHeader screen="signup" />

                    {/* Organisation details */}
                    <Row gutter={16} className={this.state.screen === 1 ? 'hide' : ''}>
                        <Col span={24}>
                            <p><b><FormattedMessage id="Signup.Title.Organisation" defaultMessage="Please provide the details of your organization" /></b></p>
                        </Col>
                        <Col span={24}>
                            <div>
                                <Form.Item colon={false} label={<FormattedMessage id="Label.Organisation" defaultMessage="Organisation name" />}>
                                    {getFieldDecorator('organizationName', {
                                        rules: [
                                            { required: true, message: <FormattedMessage id="Rules.Organisation.Required" defaultMessage="Please provide organisation" /> },
                                            { min: 2, message: <FormattedMessage id="Rules.Organisation.Min2" defaultMessage="Organisation name must be at least 2 characters" /> },
                                            { max: 50, message: <FormattedMessage id="Rules.Organisation.Max50" defaultMessage="Organisation name cannot be longer than 50 characters" /> },
                                        ]
                                    })(
                                        <Input size="large" type="text" autoComplete="off" sso-id="signup-organizationName" />
                                    )}
                                </Form.Item>
                            </div>
                        </Col>
                        <Col span={24}>
                            <div>
                                <Form.Item colon={false} label={<FormattedMessage id="Label.Industry" defaultMessage="Industry" />}>
                                    {getFieldDecorator('industry', {
                                        rules: [
                                            { required: true, message: <FormattedMessage id="Rules.Industry.Required" defaultMessage="Please provide industry" /> }
                                        ]
                                    })(
                                        <Select
                                            size="large" showSearch={Object.keys(_utils.industries).length > 5} sso-id="signup-industry"
                                            placeholder={this.props.intl.formatMessage(cw['Placeholder.Industry'])}
                                        >
                                            {Object.keys(_utils.industries).map(industry => (
                                                <Select.Option key={industry} value={industry}>{_utils.industries[industry]}</Select.Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            </div>
                        </Col>
                        <Col span={24}>
                            <Form.Item colon={false} label={<FormattedMessage id="Label.Country" defaultMessage="Country" />}>
                                {getFieldDecorator('organizationCountry', {
                                    rules: [
                                        { required: true, message: <span /> },
                                    ],
                                    initialValue: 'Ghana'
                                })(
                                    <Select size="large" showSearch={true} sso-id="signup-organizationCountry">
                                        {this.state.countries.map(cnt => (
                                            <Select.Option key={cnt.label} value={cnt.label}>{cnt.label}</Select.Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item>
                                <Button className="submitBtn" block size="large" type="primary" htmlType="submit" sso-id="signup-proceed"
                                    disabled={!getFieldsValue(['organizationName', 'industry'])} loading={this.state.submitting}
                                >
                                    <FormattedMessage id="Button.CreateAccount" defaultMessage="Create Account" />
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </React.Fragment>
        );
    }
}

const CreateAccount = Form.create({ name: 'signup' })(SignUp);
export default CreateAccount;